<mat-card appearance="outlined" style="padding: 16px;">
    <ng-container *ngIf="clientId">
    <strong>Logins</strong>
    <div style="display: flex; flex-direction: column; margin-bottom: 20px;">
        <div style="display: flex;" *ngFor="let login of logins">
            <div style="margin-right: 5px;">
                {{login.date | date: 'dd.MM.yyyy - HH:mm'}}
            </div>
            <div>
                {{glo.getUserNameMitId(login.admin)}}
            </div>
        </div>
    </div>
</ng-container>
    <strong>Bearbeitet</strong>
    <div style="display: flex; flex-direction: column;">
        <div style="display: flex;" *ngFor="let update of updates">
            <div style="margin-right: 5px;">
                {{update.updatedAtUnix | date: 'dd.MM.yyyy - HH:mm'}}
            </div>
            <div>
                {{glo.getUserNameMitId(update.updatedBy)}}
            </div>
        </div>
    </div>
</mat-card>